export default "<div class=\"pending\" *ngIf=\"isPending\"></div>\n";